<template>
  <div class="root d-inline-block">
    <div class="input-group">
      <div v-if="mode ==='view'">
        <div v-if="product.havePattern ">
          <!--<button v-if="!options.isSelectMode" class="btn btn-secondary" >
            <i class="icon-eye-outline"></i>
          </button>-->
          <div class="badge badge-info"  @click="openModal('view', product.id)" v-if="!options.isSelectMode">نمایش</div>
        </div>
        <div v-if="!product.havePattern" class="badge badge-danger">ندارد</div>
      </div>
       <!--<input v-if="mode!=='view'" class="form-control" @click="openModal">-->
      <button v-if="mode==='create'" class="btn btn-success" @click="openModal('create')">
        <i class="icon-content-duplicate"></i>
      </button>
      <button
        v-if="mode ==='edit' && product.id"
        class="btn btn-secendory"
        @click="openModal('edit', product)"
      >
        <i class="icon-bd-pencil" ></i>
      </button>
    </div>
    <b-modal
      ref="materialModal"
      id="modal-center"
      class="accounting-modal"
      centered
      size="lg"
      :title="modalTitle"
      :ok-title="'ذخیره'"
      :cancel-title="'لغو'"
      @ok="onMaterialModalOk"
    >
      <div class="row" v-if="mode === 'edit'">
        <div class="col-7  d-flex justify-content-center align-items-center">
          <vs-select
            v-if="mode === 'edit'"
            ref="selectPattern"
            :isHeader="true"
            :data="patternNames"
            :selectedVal="model"
            :header="{label:'name'}"
            :mode="'edit'"
            v-model="account"
          ></vs-select>
        </div>
        <div class="col-2 d-flex justify-content-center align-items-center">
          <b-form-checkbox
            id="defaultChecked"
            v-model= defaultChecked
            name="defaultChecked"
            value=true
            unchecked-value=false
          >
            پیش فرض
          </b-form-checkbox>
        </div>
        <div class="col-2 d-flex justify-content-center align-items-center">
          <button class="btn btn-success" :class="{visible : patternChangeFlag === true}" @click="submitPattern">افزودن الگو</button>
        </div>
      </div>
      <vs-table v-if="show" ref="materialTable" :params="tableParams" :options="tableOptions"></vs-table>
    </b-modal>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from "vuex";
  import BaseService from "../_framework/api/BaseService.js";
  import Utils from "../_framework/utils/Utils.js";
  import VsSelect from "../_framework/VsSelect";
  import VsTableMixin from "../_framework/VsTableMixin.js";
  import DatePicker from "../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Products from "../pages/Products.vue";
  import PatternModalHeader from "../components/PatternModalHeader";
  import Patterns from "../pages/taskFlow/Patterns.vue";
  import EventBus from "../bus.js";
  import ClientSelect from "../components/ClientSelect.vue";
  import SetDefaultValue from "../components/SetDefaultValue";
  export default {
    name: "pattern-modal",
    props: {
      headerKey: null,
      row: null,
      mode: {
        default: "view",
        type: String
      },
      params: {},
      options: {},
      entity: ""
    },
    mixins: [VsTableMixin],
    components: {
      VsSelect,
      datePicker: DatePicker,
      PatternModalHeader,
    },
    data() {
      return {
        defaultChecked: false,
        patternChangeFlag: false,
        selectedProduct: {},
        productId: null,
        show: false,
        account: null,
        model: null,
        pattern: [],
        patternNames: [],
        modalTitle: "الگوی اختصاص داده شده به محصولات",
        documentDate: null,
        servicesList: [],
        selectedServices: [],
       /* service: {
          id: 0,
          title: "",
          price: "",
          sessionQuantity: "",
          description: ""
        },*/
        /*doc: {
          id: 0,
          number: "",
          documentId: "",
          date: "",
          attachment: "",
          description: "",
          total: "",
          remaining: ""
        },*/
        tableParams: {
          list: [],
          entity: "",
          headers: {
            /*DefaultPattern: {
              title: "افزودن الگو",
              type: "custom",
              component: PatternModalHeader,
              grow: 1.7,
              flex: 1,
              rowAlignment: "center"
            },*/
            productName: {
              title: "نام محصول",
              type: "text",
              rowAlignment: "center"
            },
            patternName: {
              title: "نام الگو",
              type: "text",
              rowAlignment: "center"
            },
            isDefault: {
              title: "الگوی پیش فرض",
              type: "custom",
              component: SetDefaultValue,
              rowAlignment: "center"
            }
          }
        },
        tableOptions: {
          dataSourceType: "store",
          beforeCreateEntity: input => {
            if (this.mode === "create") {
              this.updateMaterialTable(input);
              // input.id = Math.random() * 1000;
              return null;
            } else {
              if (input && input["material"]) {
                input["material"] = input["material"].id;
              }
              input.productId = this.product.id;
              return input;
            }
          },
          beforeDeleteEntity: input => {
            if (this.mode === "create") {
              this.deletePatternTableRow(input.id);
              return null;
            } else {
              return input;
            }
          },
          beforeFetchEntityList: input => {
            if (this.product && this.product.id)
              input.productId = this.product.id;
            return input;
          },
          hasActions: false,
          onRowClicked: row => {},
          hasActionsInHeader: false,
          clickableRows: true,
          onEditClicked: (row, context) => {
              /*this.productVoucherModel = row;
              this.productVoucherModel.type = "Edit";
              this.openProductDetailModal();*/
          },
          onRowDoubleClicked: row => {
            //   this.productVoucherModel.type = "View";
            //   this.productVoucherModel = row;
            //   this.openProductDetailModal();
          }
        }
      };
    },
    mounted() {

    },
    beforeMount() {
      if (this.row) {
        this.product = this.row;
        this.modalTitle = this.modalTitle + " " + this.product.productName;
      }
      if (this.$route && this.$route.path) {
        this.tableOptions.access = checkAccess(this.$route.path);
      } else {
        // change from  products to patterns
        this.tableOptions.access = checkAccess("patterns");
      }
    },
    methods: {
      patternsList() {
        new BaseService('Patterns', '/GetAllPatterns/').getList().then((response) => {
          console.log(response.data);
          this.patternNames = response.data;
        }).catch((error) => {
          console.log(error)
        }).then(() => {

        });
      },
      getProductPatterns(id) {
        if (this.mode !== "create" && this.mode !== "edit" || this.mode === "view") {
          new BaseService('Patterns', `/GetProductPatterns/${id}`).getList().then((response) => {
            console.log(response.data);
            for(let item  of response.data) {
              this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", item);
            }
            //this.tableParams.list = response.data;
          }).catch((error) => {
            console.log(error)
          }).then(() => {

          });
        }
      },
      /*onValueChanged(val) {
        console.log(val);
        this.patternChangeFlag = true;
        // this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED");
        /!* this.$emit("dataChanged", this.headerKey, val);
         EventBus.$emit("onSelectAccountTitle", val);*!/
      },*/
      submitPattern() {
        console.log(this.$refs.selectPattern.selectedValue);
        let model = {
          isDefault: JSON.parse(this.defaultChecked),
          patternId: this.$refs.selectPattern.selectedValue.id,
          productId: this.selectedProduct.id
        };
        new BaseService('Patterns', '/CreateProductPattern').create(model).then((response) => {
          console.log("pattern send");
        }).catch((error) => {
          console.log(error)
        });

        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          // id: Math.random() * 100,
          productName: this.selectedProduct.productName,
          patternName: this.$refs.selectPattern.selectedValue.name,
          // defaultValue : data.defaultValue
        });
      },
      openModal(mode, product) {
        this.patternsList();
        this.selectedProduct = product;
        this.show = true;
        this.tableOptions.headerActionsMode = mode;
        if (mode === "create") {
          this.tableOptions.clearStoreOnMount = true;
          this.tableOptions.dataSourceType = "store";
          this.tableOptions.hasActions = true;
          this.tableOptions.hasActionsInHeader = true;
        } else {
          this.tableOptions.dataSourceType = "store";
          if (mode === "view") {
            this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
            this.tableOptions.hasActions = false;
            this.tableOptions.hasActionsInHeader = false;
          }
          if (mode === "edit") {
            // this.tableOptions.dataSourceType = "store";

            this.tableOptions.hasActions = false;
            this.tableOptions.hasActionsInHeader = false
          }
        }
        if (this.$refs) {
          this.$refs.materialModal.show();
          this.$refs.materialTable &&
          this.$refs.materialTable.onFetchEntityListRequested();
        }
        this.refreshMaterialTable();
        setTimeout(() => {
          this.getProductPatterns(product);
        }, 500)
      },
      setDateFromDatePicker(date) {
        this.documentDate = date;
      },
      toggleDatePicker() {
        this.$refs.datePicker.togglePicker();
      },
      btnClicked() {
        this.$refs.materialModal.show();
        this.calculatePrependWidth();
      },
      onMaterialModalOk() {
        this.$emit(
          "dataChanged",
          this.headerKey,
          this.vsTableFeed.map(m => {
            return m;
          })
        );
        if (this.mode !== "create") {
          EventBus.$emit("materialChanged");
        }
      },
      updateMaterialTable(data) {
        this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
          id: Math.random() * 100,
          material: data.material,
          percentage: data.percentage
          // defaultValue : data.defaultValue
        });
        //   this.voucherModel.voucherProductDto.push({
        //   productId: data.productId,
        //   unitVal: data.number || data.unitVal,
        //   price: data.price,
        //   productName: data.productName
        // });
      },
      deletePatternTableRow(id) {
        this.$store.commit("DELETE_ROW_FROM_VS_TABLE_FEED", id);
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      },
      refreshMaterialTable() {
        this.show = false;
        setTimeout(() => {
          this.show = true;
        }, 50);
      }
    },
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"])
    },
    watch: {
      vsTableFeed(val) {
        // this.refreshMaterialTable();
      },
      row(val) {
        this.pattern = val;
        this.modalTitle = "اگوی اختصاص داده شده به محصوات" + this.pattern.patternName;
        if (this.mode === "create") {
          this.tableParams.dataSourceType = "store";
        } else {
          this.tableParams.dataSourceType = "api";
        }
      }
    }
  };
</script>

<style scoped>
  hr {
    background-color: rgba(255, 255, 255, 0.4);
  }

  .input-group > div:not(.custom) {
    display: flex;
    flex: 1;
  }
</style>
